<template>
  <div class="flex w-full">
    <a  v-for="perfil in perfis" class="disabled" v-bind:class="onCursorIndicado" v-on:click.prevent="onClickedCard(menu.namePath)">
      <div v-if="perfil===title" class="flex flex-row items-center">
        <div class="tamanhoCard bg-white border hover:shadow-2xl shadow rounded-lg items-center">
          <div class="flex flex-row h-full border bg-gray-50 hover:bg-gray-100">
            <div class="flex flex-col h-full px-4 bg-gray-50">
              <span v-html="menu.icone" class="my-auto cor-principal"></span>
            </div>
            <div class="flex-col my-auto ">
              <h1 class="text-lefttext-lg font-normal uppercase roboto px-2 mx-2">{{modulo.name}}</h1>
              <h1 class="text-justify text-xxs font-normal text-gray-700 font-sans roboto mx-2 px-2">{{menu.subtitle}}</h1>
            </div>
          </div>

          <div class="flex flex-col flex-wrap justify-around">

          </div>
          <div class="flex flex-row flex-wrap justify-around mt-4">

          </div>
          <div id="rodape" class="flex flex-row h-12 mt-2">
          </div>
        </div>
      </div>
    </a>
  </div>

</template>
<script>
import CardIcon from './cardIcon'

export default {
  name: 'cardModules',
  data() {
    return {
      mostraCursorLink: false
    }
  },
  props: {
    title: {
      type: String,
      default: 'titulo'
    },
    subtitle: {
      type: String,
      default: 'subtitulo'
    },
    menu: {
      type: Object
    },
    modulo: {
      type: Object
    },
    perfis:{
      type:Array
    },
    perfil:{
      type:String
    }
  },
  components: {
    CardIcon
  },
  computed: {
    onCursorIndicado: function () {
      if(this.menu.active===true){
        return 'cursor-pointer';
      }else{
        return 'cursor-not-allowed';
      }

    },
    onNamePath() {
      return this.menu.namePath || '/'
    }
  },
  methods: {
    async onClickedCard(path) {
      if(this.menu.active && this.menu.namePath){
        if (this.menu.namePath === 'administrador') {
          this.$router.push({ path: `/usuario` });
        } else {
          const local = process.env.VUE_APP_FRONTEND_BASE || "http://gestaodepessoas-semed.desenvolvimento.am.gov.br/";
          window.location.href = local + path;
        }
      }
    }
  }
}
</script>

<style scoped>
#rodape {
  background-repeat: no-repeat;
  background-size: cover;
  /*background-position: center;*/
}

.tamanhoCard{
  width: 22rem;
  height: 12rem;
}
</style>
